import React, { Component, useRef } from "react";
import html2canvas from 'html2canvas';
import { connect } from "react-redux";
import Trevo from "../../static/svg/trevo.svg";
import TrevoQuina from "../../static/svg/trevoQuina.svg";
import GloboLoteria from "../../static/svg/globoLoteria.svg";
import { convertDate, convertIntegerToMoney } from "../../modules/helpers";
import ResultCard from "../../rifa/components/layout/resultCard";
import Icon from "../../rifa/components/layout/icon";
import { generateImage, shareImage } from "../../newDesign/utils/generateImage";
import Button from "../../rifa/components/layout/button";
import { getNumberLength } from "../../rifa/utils/getNumberLength";
import { hasBitLogin, hasLogin } from "../../utils/getPreTickets";
class BilheteCard extends Component {
  getApostaLoteriaDetailsBody(ap) {
    return (
      <tbody>
        <tr style={{ fontSize: "18px", color: "#444" }}>
          <td>
            <b>{`${ap.nome} :  ${ap.arrNumeros.join(" - ")}`}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{`Prêmio: ${ap.premio}`}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{`Valor: R$ ${convertIntegerToMoney(
              ap.valor
            )} - Valor Total: R$ ${convertIntegerToMoney(ap.valorTotal)}`}</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>{`Possível Retorno: R$ ${convertIntegerToMoney(
              ap.possivelRetorno
            )}`}</b>
          </td>
        </tr>
      </tbody>
    );
  }

  // Quininha e Seninha
  getApostaJogoDetailsBody(ap) {
    return (
      <tbody>
        <tr>
          <td>
            <b>{` ${ap.nome} a R$ ${convertIntegerToMoney(ap.valor)}  com ${ap.arrNumeros.length
              } dezenas (paga ${ap.possivelRetorno.toLocaleString(
                "pt-BR"
              )}x)`}</b>
          </td>
        </tr>
        <tr>
          <td style={{ fontSize: "13px", color: "#444" }}>
            <b>{`Possível Prêmio: R$ ${convertIntegerToMoney(
              ap.valor * ap.possivelRetorno
            )}`}</b>
          </td>
        </tr>
        <tr>
          <td>
            <span>{ap.arrNumeros.join(" - ")}</span>
          </td>
        </tr>
      </tbody>
    );
  }

  getApostaDetails(arrJogo, isLoteria) {
    return (
      <div>
        {arrJogo.map((ap) => {
          return (
            <div key={ap.Aposta_ID}>
              <table>
                {isLoteria
                  ? this.getApostaLoteriaDetailsBody(ap)
                  : this.getApostaJogoDetailsBody(ap)}
              </table>
            </div>
          );
        })}
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.divRef = React.createRef();
  }

  render() {
    let Bilhete = this.props.Bilhete;
    let flatTop = this.props.flatTop;

    let headerImage = null;
    let strJogoExtracao = null;
    let strJogoConcurso = null;

    let isLoteria = !Bilhete.bitConcurso;

    const numberLength = getNumberLength(this.props.objTipoJogo);

    if (!isLoteria) {
      headerImage = (
        <img
          src={[555, 5555].includes(Bilhete.sntTipoJogo) ? TrevoQuina : Trevo}
          alt={Bilhete.vchNome}
          className="img"
          style={{ marginRight: "0px" }}
        />
      );
      strJogoConcurso = `${convertDate(Bilhete.sdtDataJogo)} ${Bilhete.vcHorarioSorteio.length > 0 ? Bilhete.vcHorarioSorteio : ""
        }`;
    } else {
      headerImage = (
        <img
          src={GloboLoteria}
          alt={Bilhete.vchNome}
          className="img"
          style={{ marginRight: "0px" }}
        />
      );
      strJogoExtracao = `${Bilhete.vchExtracao} - ${Bilhete.sdtDataAposta}`;
    }
    const hasEarned = !!Bilhete.numPremioTotal || !!Bilhete.numValorPremioCotaTotal;

    return (
      <div
        className="modal-content bilhete"
        style={{
          borderTopLeftRadius: flatTop ? "0px" : undefined,
          borderTopRightRadius: flatTop ? "0px" : undefined,
        }}
        ref={this.divRef}
      >
        <div className="modal-header bilhete">
          <div className="modalidade_row" style={{ display: "flex" }}>
            <span>
              <h4>Comprovante de aposta</h4>
            </span>
          </div>
        </div>
        <div className="modal-body bilhete-header">
          <p className="modal-title">
            <strong>Aposta realizado em: </strong>
            <span>
              {`${Bilhete.sdtDataHora}`} ({this.props.objUser.chrUF})
            </span>
          </p>
          <p className="modal-title">
            <strong>Venda: </strong>
            <span>{Bilhete.vchETicket}</span>
          </p>
          <p className="modal-title">
            <strong> Bilhete:</strong>
            <span> {Bilhete.intNumeroPule}</span>
          </p>
          <p className="modal-title">
            <strong>Código de Segurança:</strong>
            <span>{Bilhete.vchCodigoSeguranca}</span>
          </p>
          {strJogoConcurso && (
            <p className="modal-title">
              <strong>Concurso: </strong>
              <span>{strJogoConcurso}</span>
            </p>
          )}
          {strJogoExtracao && (
            <p className="modal-title">
              <strong>Extração: </strong>
              <span>{strJogoExtracao}</span>
            </p>
          )}
          <hr className="divider"></hr>
          <p className="modal-title">
            <strong>Total apostado: </strong>
            <span>
              R$ {convertIntegerToMoney(Bilhete.numValorApostas * 100)}
            </span>
          </p>
          {Bilhete.vchCodigoSeguranca &&
            <p className="modal-title">
              <strong>Código de segurança: </strong>
              <span>
                {Bilhete.vchCodigoSeguranca}
              </span>
            </p>
          }
          {hasEarned &&
            <p className="modal-title">
              <strong>Valor premiado: </strong>
              <span className="earnedPrizeValue">
                {convertIntegerToMoney(Math.max(Bilhete.numPremioTotal, Bilhete.numValorPremioCotaTotal) * 100)}
              </span>
            </p>
          }
        </div>
        <div className="modal-body">
          {Bilhete.arrJogo.map((jogo, index) => {
            return (
            <ResultCard
              isBallType={!isLoteria}
              index={index + 1}
              title={jogo.nome}
              key={jogo.nome}
              valorTotal={convertIntegerToMoney(jogo.valorTotal)}
              numbers={jogo.arrNumeros}
              premio={jogo.premio}
              numberLength={numberLength}
              tipoJogo={jogo.tipoJogo}
              earned={jogo.earned}
              earnedFromQuota={jogo.earnedFromQuota}
            />
          )})}
        </div>
        {Bilhete.arrResultado.length > 0 &&
          <div className="modal-body" style={{ marginBottom: 30 }}>
            <div className="modalidade_row" style={{ display: "flex" }}>
              <strong>
                <h4>Resultados</h4>
              </strong>
            </div>
            <ResultCard
              isBallType={!isLoteria}
              numbers={Bilhete.arrResultado}
              numberLength={numberLength}
              tipoJogo={jogo.tipoJogo}
            />
          </div>
        }
        <div className="modal-footer">
          { !hasBitLogin() ?
          <div className="rifa-ticket__buttons">
            <Button
              color="main"
              onClick={() => generateImage(this.divRef, null, Bilhete.vchETicket) }
            >
              <Icon type="download" color="white" />
              Baixar Comprovante
            </Button>
            <Button
              color="main"
              onClick={() => { shareImage(this.divRef, null, Bilhete.vchETicket) }}
            >
              <Icon type="share" color="white" />
            </Button>
          </div>
            : null}
          <h5 className="row modal-message">
            {this.props.objUser.vchMensagemPule}
          </h5>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    objUser: state.usuario.objUser,
  };
};

export default connect(mapStateToProps)(BilheteCard);



// WEBPACK FOOTER //
// ./src/common/bilheteCard/bilheteCard.jsx